export default "__VITE_ASSET__R7VvJ04g__"